import axiosClient from './axiosClient';

export const apiDownLoadPDF = (data: any) => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/documents/api/download-pdf`;
    return axiosClient.post(url, data, { responseType: 'blob' });
};
